export default __webpack_public_path__ + "static/media/Sizzling_bliss_large_4.c07e2854.jpg";